import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPin = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.32129 13.6786L5.76601 10.2338M5.76601 10.2338C4.72845 9.19628 3.78352 8.07814 2.90362 6.90494C2.8032 6.77104 2.81651 6.58368 2.93487 6.46533C3.68459 5.7156 4.77194 5.4128 5.80126 5.66711C6.27783 5.78485 6.77328 5.66985 7.04482 5.22579L8.509 2.83143C8.84788 2.27726 9.59936 2.1524 10.0992 2.56719C11.3181 3.57862 12.4212 4.68172 13.4327 5.90062C13.8475 6.4005 13.7226 7.15198 13.1684 7.49085L10.7741 8.95504C10.33 9.22658 10.215 9.72202 10.3327 10.1986C10.5871 11.2279 10.2843 12.3153 9.53453 13.065C9.41618 13.1833 9.22881 13.1967 9.09491 13.0962C7.92172 12.2163 6.80358 11.2714 5.76601 10.2338Z",
		stroke: "currentColor",
		strokeWidth: 1.3,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgPin);
export default ForwardRef;
